import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import LayoutHeader from "../../layout/LayoutHeader";
import { removeUploadsFromUrl } from "../../components/DizeeComponent/DixeeInput2";
// import { Play, Pause, SkipBack, SkipForward } from "lucide-react";
import BackImg from '../../assets/images/Back.svg'
import NextImg from '../../assets/images/Next.svg'
import PlayImg from '../../assets/images/Play.svg'
import PauseImg from '../../assets/images/Pause.svg'

export function Slider({ value, max, onChange, className }) {
  console.log(`max::`, max)
  console.log(`value[0]::`, value[0])
  const percent = (value[0] / max) * 100;
  return (
    <input
      type="range"
      min="0"
      max={max}
      value={value[0]}
      step="0.0001"
      onChange={(e) => onChange([parseFloat(e.target.value)])}
      style={{
        background: `linear-gradient(to right, #ffffff ${percent}%, #ffffff1f ${percent}%)`,
      }}
      className={`w-full h-1 bg-gray-700 rounded-lg appearance-none cursor-pointer ${className}`}
    />
  );

}

const formatTime = (seconds) => {
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  const paddedMins = hrs > 0 ? String(mins).padStart(2, '0') : mins;
  const paddedSecs = String(secs).padStart(2, '0');

  return hrs > 0
    ? `${hrs}:${paddedMins}:${paddedSecs}`
    : `${paddedMins}:${paddedSecs}`;
}

export default function StreamOverlay() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const data = useSelector((state) => state.vaultData.curPlayStreamData);
  const vaultData = useSelector((state) => state.vaultData);
  const userArticle = useSelector((state) => state.user.userArticle);

  const [isPlaying, setIsPlaying] = useState(false);
  const [renderTime, setRenderTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const audioRef = useRef(null);
  const animationFrameRef = useRef(null);

  useEffect(() => {
    // Create a new Audio object when data.file changes
    if (!data?.file) return;

    const audio = new Audio(data.file);
    audioRef.current = audio;

    const onLoadedMetadata = () => {
      setDuration(audio.duration);
    };

    const updateTime = () => {
      setRenderTime(audio.currentTime);
      animationFrameRef.current = requestAnimationFrame(updateTime);
    };

    audio.addEventListener("loadedmetadata", onLoadedMetadata);
    animationFrameRef.current = requestAnimationFrame(updateTime);

    return () => {
      audio.pause();
      cancelAnimationFrame(animationFrameRef.current);
      audio.removeEventListener("loadedmetadata", onLoadedMetadata);
    };
  }, [data.file]);

  const togglePlayPause = () => {
    if (!audioRef.current) return;
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  const handleSliderChange = (value) => {
    if (!audioRef.current) return;
    audioRef.current.currentTime = value[0];
    setRenderTime(value[0]);
  };

  return (
    <LayoutHeader>
      <div className="w-[350px] sm:max-w-[390px] pb-[100px] h-full flex flex-col justify-start items-center relative rounded-[20px] bg-black overflow-hidden">
        <div className="absolute top-6 left-4 z-10">
          <button
            onClick={() => navigate(-1)}
            className="text-white text-[12px] hover:text-white transition-colors duration-200"
          >
            BACK
          </button>
        </div>

        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            opacity: (userArticle?.noise || 0) / 100,
            mixBlendMode: "overlay",
            pointerEvents: "none",
            zIndex: 2,
            borderRadius: "20px",
          }}
        />

        <div className="flex py-4 z-1 ml-4 w-full justify-center items-center text-white">
          <div className="cursor-pointer mx-auto flex justify-center items-center gap-x-[4px] text-xl font-medium">
            {data?.title || "Stream Player"}
          </div>
        </div>

        <div
          className="w-[350px] sm:max-w-[390px] pb-[16px] h-full flex flex-col justify-start items-center relative rounded-[20px]"
          style={{
            filter: `grayscale(${userArticle?.grayscale}%)`,
            backgroundColor: `${userArticle?.background ? "#" + userArticle?.background : "#000000"}`,
            position: "relative",
          }}
        >
          <div className="relative z-2 w-full">
            <div className="w-full h-[550px] relative rounded-t-[20px] overflow-hidden mb-[40px]">
              <img
                src={
                  vaultData.image
                    ? vaultData.image
                    : removeUploadsFromUrl(`${userArticle?.avatar}`)
                }
                alt="photoimage"
                className="w-full h-full object-cover object-center"
                style={{ minHeight: "550px" }}
              />
              <div
                className="absolute bottom-0 left-0 w-full h-1/3 bg-gradient-to-t to-transparent flex justify-between items-end p-4"
                style={{
                  backgroundImage: `linear-gradient(to top, #000000, transparent)`,
                }}
              />
            </div>
          </div>
        </div>

        <div className="flex flex-col w-full p-2 mt-[-90px] z-10">
          <div className="mt-4 text-center">
            <h2 className="text-xl font-bold">{data.title}</h2>
            <p className="text-sm text-gray-400">{data.artist}</p>
            <Slider
              value={[renderTime]}
              max={duration || 100}
              onChange={handleSliderChange}
              className="mt-4"
            />
            <div className="flex flex-row justify-between items-center mt-4">
              <span className="text-[#ffffff80]">{formatTime(Math.floor(renderTime))}</span>
              <span className="text-[#ffffff80]">{formatTime(Math.floor(duration))}</span>
            </div>
            <div className="flex flex-row justify-center mt-[-16px]">
              <div className="flex w-[120px] justify-between items-center">
                {/* <SkipBack className="w-6 h-6 text-gray-400" /> */}
                <img src={BackImg} alt="" className="cursor-pointer" />
                <button
                  onClick={togglePlayPause}
                  className="w-12 h-12 bg-transparent rounded-full flex items-center justify-center"
                >
                  {isPlaying ? (
                    // <Pause className="w-6 h-6" />
                    <img src={PauseImg} alt="" />
                  ) : (
                    <img src={PlayImg} alt="" />
                    // <Play className="w-6 h-6" />
                  )}
                </button>
                {/* <SkipForward className="w-6 h-6 text-gray-400" /> */}
                <img src={NextImg} alt="" className="cursor-pointer" />

              </div>
            </div>
          </div>
        </div>
      </div>
    </LayoutHeader>
  );
}
